// A TableAction is an abstract implementation for a bulk multi-edit action
// performed on a table's dataset.
export default class TableAction {
  id;

  label;

  hidden;

  // Called when this action is 'clicked'. This is any initiator to begin the operation.
  /* eslint-disable class-methods-use-this, no-unused-vars */
  doOpen = ({ column, editRows, setCurrentlyEditing, currentEditor, setCurrentEditor }) => {
    setCurrentEditor(column);
    setCurrentlyEditing(editRows);
  };

  // Called when this action is canceled or closed.
  /* eslint-disable class-methods-use-this, no-unused-vars */
  doClose = ({ currentlyEditing, setCurrentlyEditing, currentEditor, setCurrentEditor }) => {
    setCurrentEditor({});
    setCurrentlyEditing([]);
  };

  // Save operations are called when data is going to be manipulated as a result of this action.
  /* eslint-disable class-methods-use-this, no-console */
  doSave = (data, params) => {
    console.log(`saving ${data.length} rows, with params ${params}`);
  };

  // This is intended to be used by providing in the relevant callback overrides
  // which will be called by the data table at appropriate times.
  constructor({ id, label, doOpen, doClose, doSave, hidden = false }) {
    this.id = id;
    this.label = label;
    this.hidden = hidden;
    if (doOpen) this.doOpen = doOpen;
    if (doClose) this.doClose = doClose;
    if (doSave) this.doSave = doSave;
  }
}
